import { t } from '@moovly/i18n';
import { Button, useModal } from '@moovly/ui';
import PurchaseSubscriptionModal from '../modals/PurchaseSubscriptionModal';

const PurchaseSubsriptionButtonContainer = () => {
  const { isOpen, openModal, ...otherModalProps } = useModal();
  return (
    <>
      <Button onClick={openModal} label={t('subscription.purchase')} className="float-end" />
      {isOpen && <PurchaseSubscriptionModal {...otherModalProps} />}
    </>
  );
};

export default PurchaseSubsriptionButtonContainer;
